<template>
  <div id="notificationPanel" class="fixed bottom-0 mb-26 px-26 z-70 w-100vw md:w-full cursor-pointer">
    <div v-if="currentResult && showFomoNotifications"
         class="notification-panel border-l-4 border-orange bg-white items-center"
         :class="showClass">
      <button v-on:click="hideFomoNotifications()" class="absolute top-0 right-0 p-4 focus:outline-none">
        <i class="fas fa-times text-gray"></i>
      </button>

      <div class="grid grid-cols-6 w-full" v-on:click="notificationAction()">
        <div>
          <img class="h-100 object-cover mr-12" alt=""
               :src="currentResult.image">
        </div>
        <div class="ml-8 col-span-5 pt-20 pr-8">
          <p>
            <span class="truncate font-black mb-4 block">
              {{ currentResult.heading }}
            </span>
          </p>
          <p class="mt-4">
            <span class="italic truncate">{{ currentResult.subHeading }}</span>
          </p>
          <p class="mt-8">
            <span class="truncate text-14" v-html="currentResult.message"></span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FomoNotifications",

  data() {
    return {
      currentResult: null,
      showClass: '',
      showFomoNotifications: true,
      fomoNotificationsDuration: 8000,
      fomoNotificationsInterval: 4000,
      results: []
    }
  },

  mounted() {
    axios.get('/web/api/fomo-notifications')
      .then(response => {
        this.results = response.data.data

        let meta = response.data.meta;

        if (!meta.can_show_fomo_notifications) {
          this.showFomoNotifications = false
          return
        }

        this.fomoNotificationsDuration = meta.fomo_notifications_duration
        this.fomoNotificationsInterval = meta.fomo_notifications_interval

        this.initialize()
      })
  },

  methods: {
    async initialize() {
      let count = window.localStorage.getItem('recently-sold-item-index') !== null
        ? parseInt(window.localStorage.getItem('recently-sold-item-index')) + 1
        : 0;

      for (let i = count; i < this.results.length; i++) {
        if (!this.showFomoNotifications) {
          break
        }

        this.currentResult = this.results[i]
        await this.sleep(3000)
        window.localStorage.setItem('recently-sold-item-index', i)

        this.toggleNotificationPanel()
        await this.sleep(this.fomoNotificationsDuration)
        this.toggleNotificationPanel()
        await this.sleep(this.fomoNotificationsInterval)

      }
    },

    sleep(milliseconds) {
      return new Promise((resolve) => setTimeout(resolve, milliseconds));
    },

    toggleNotificationPanel() {
      if (this.showClass.length) {
        this.showClass = ''
      } else {
        this.showClass = 'show'
      }
    },

    hideFomoNotifications() {
      window.localStorage.removeItem('recently-sold-item-index')
      this.toggleNotificationPanel()
      this.showFomoNotifications = false
      axios.post('/web/api/fomo-notifications/disable')
    },

    notificationAction() {
      window.location = this.currentResult.url
    }
  }
}
</script>

<style scoped>
@media (min-width: 764px) {
  #notificationPanel {
    max-width: 400px;
  }
}

.notification-panel {
  position: relative;
  display: flex;
  box-shadow: 0 0 25px 5px rgb(0 0 0 / 25%);
  transition: transform 500ms linear;
  transform: translateX(-764px);
  will-change: transform;
}

.show {
  transform: translateX(0px);
}
</style>
